const NomaCareProductFinder = class NomaCareProductFinder extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    const liveProducts = parseJsonScript(this, '[data-live-products]');

    this.catalogue = prepareLiveProducts(liveProducts);
    this.resultLimit = Math.max(2, Math.min(4, Number(this.dataset.resultLimit || 3)));
    this.showPrices = this.dataset.showPrices !== 'false';

    this.journey = this.querySelector('[data-finder-journey]');
    this.form = this.querySelector('[data-finder-form]');
    this.questionTitle = this.querySelector('[data-question-title]');
    this.questionCopy = this.querySelector('[data-question-copy]');
    this.optionContainer = this.querySelector('[data-question-options]');
    this.error = this.querySelector('[data-question-error]');
    this.actions = this.querySelector('.nc-product-finder__actions');
    this.backButton = this.querySelector('[data-back]');
    this.nextButton = this.querySelector('[data-next]');
    this.progressRegion = this.querySelector('.nc-product-finder__progress');
    this.progress = this.querySelector('[data-progress]');
    this.progressValue = this.querySelector('[data-progress-value]');
    this.progressLabel = this.querySelector('[data-progress-label]');
    this.progressCount = this.querySelector('[data-progress-count]');
    this.results = this.querySelector('[data-results]');
    this.resultsHeading = this.querySelector('[data-results-heading]');
    this.selectionSummary = this.querySelector('[data-selection-summary]');
    this.resultsExplanation = this.querySelector('[data-results-explanation]');
    this.resultGrid = this.querySelector('[data-result-grid]');
    this.careNotice = this.querySelector('[data-care-notice]');
    this.careTitle = this.querySelector('[data-care-title]');
    this.careCopy = this.querySelector('[data-care-copy]');
    this.compareBar = this.querySelector('[data-compare-bar]');
    this.compareCount = this.querySelector('[data-compare-count]');
    this.compareGuidance = this.querySelector('[data-compare-guidance]');
    this.openComparisonButton = this.querySelector('[data-open-comparison]');
    this.comparison = this.querySelector('[data-comparison]');
    this.comparisonHead = this.querySelector('[data-comparison-head]');
    this.comparisonBody = this.querySelector('[data-comparison-body]');
    this.comparisonHeading = this.querySelector('[data-comparison-heading]');
    this.closeComparisonButton = this.querySelector('[data-close-comparison]');

    this.answers = {};
    this.route = ['category', 'targets', 'format', 'context'];
    this.stepIndex = 0;
    this.selectedForComparison = new Set();
    this.currentMatches = [];

    this.form?.addEventListener('submit', (event) => event.preventDefault());
    this.nextButton?.addEventListener('click', () => this.goForward());
    this.backButton?.addEventListener('click', () => this.goBack());
    this.querySelector('[data-restart]')?.addEventListener('click', () => this.restart());
    this.openComparisonButton?.addEventListener('click', () =>
      this.renderComparison({ focus: true, scroll: true }),
    );
    this.closeComparisonButton?.addEventListener('click', () =>
      this.closeComparison({ scroll: true, restoreFocus: true }),
    );

    this.renderQuestion();
  }
};
window.NomaCareProductFinder = NomaCareProductFinder;
